import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 48, marginBottom: 16, color: 'var(--c-primary)' }}>◌</div>
          <p style={{ color: 'var(--c-text-muted)' }}>Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user.status !== 'approved') {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
        <div style={{ textAlign: 'center', maxWidth: 400 }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>
            <span style={{ color: user.status === 'pending' ? 'var(--c-primary)' : 'var(--c-error)' }}>
              {user.status === 'pending' ? '◌' : '✗'}
            </span>
          </div>
          <h2 style={{ marginBottom: 12 }}>
            {user.status === 'pending' ? 'Awaiting Approval' : 'Access Denied'}
          </h2>
          <p style={{ color: 'var(--c-text-muted)', lineHeight: 1.6 }}>
            {user.status === 'pending'
              ? 'Your account is pending approval from an administrator. You will receive an email once your account has been approved and you can access the member portal.'
              : 'Your account access has been declined. If you believe this is an error, please contact admin@rdf.global.'}
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};
